export const LOCAL_STORAGE_TOKEN_KEY = "token";
